import ObjArrUtils from '@/utils/ObjArrUtils'
import { Base } from '@/store/base/module'

const module = {
  state: {
    supportContent: null,
    isLoading: false,
    isSupportAvailable: false,
    errorMessage: null,
    supportNo: null,
  },

  getters: {},
  mutations: {},

  actions: {
    async C00103_getSupportContent({ commit, state, getters }, supportNo) {
      commit('setState', {
        isLoading: true,
        supportContent: null,
        isSupportAvailable: false,
        errorMessage: null,
        supportNo
      })

      try {
        const res = await $this.$api.postData({
          data: {
            getSupportContent: {
              api: 'M0050SupportService.C00103_getSupportContent',
              input: { support_no: supportNo }
            }
          }
        })

        const result = res.getSupportContent.output
        commit('setState', {
          supportContent: result.content,
          isSupportAvailable: result.available,
          errorMessage: result.message || null,
          isLoading: false
        })

        // return {
        //   success: true,
        //   available: result.available,
        //   data: result.content,
        //   message: result.message
        // }
      } catch (error) {
        commit('setState', {
          isLoading: false,
          isSupportAvailable: false,
          errorMessage: window.vue.$i18n.t('C00103.C00103Store.herupunonishimashita')
        })

        // return {
        //   success: false,
        //   available: false,
        //   message: 'ヘルプの取得に失敗しました'
        // }
      }
    },

    // Reset state action
    C00103_resetState({ commit }) {
      commit('setState', {
        supportContent: null,
        isLoading: false,
        isSupportAvailable: false,
        errorMessage: null,
        supportNo: null
      })
    }
  }
}

export default ObjArrUtils.merge(Base, module)
